import { ARROW_OPTIONS } from './LineWidgetToolbar.config';

const BUTTON_ICON_WIDTH = '16px';
export const generateArrowStyleOptions = (isStart: boolean) => {
  const additionalStyle = isStart ? {} : { transform: 'scaleX(-1)' };
  return ARROW_OPTIONS.map((option) => {
    const { value, label, iconComponent: IconComponent } = option;

    return {
      value,
      label,
      icon: <IconComponent style={additionalStyle} />,
      buttonIcon: <IconComponent style={additionalStyle} width={BUTTON_ICON_WIDTH} />,
    };
  });
};
